<h2 mat-dialog-title class="overview-dialog-title">
  <mat-icon class="overview-title-icon">today</mat-icon>
  Today's Overview
  <button mat-icon-button type="button" class="overview-close-btn" (click)="close()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="overview-dialog-content">
  <app-today-overview></app-today-overview>
</mat-dialog-content>
